import React from 'react';
interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}
export function PageTransition({
  children,
  className = ''
}: PageTransitionProps) {
  return <div className={`animate-page-enter ${className}`} data-id="element-1074">{children}</div>;
}